import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
  images,
  signUpImages,
  animeSchedule,
} from '../../services/images.service'
import { login, loginWithGoogle } from '../../store/slices/user.slice'
import { openSignUp } from '../../store/slices/ui.slice' // ייבוא הפעולה לפתיחת Signup
import { Button } from '../../cmps/ui/elements'

export function Login({ onClose }) {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  })

  function togglePasswordVisibility() {
    setShowPassword((prev) => !prev)
  }

  function handleChange({ target }) {
    const { name, value } = target
    setCredentials({ ...credentials, [name]: value })
  }

  async function onLogin(ev) {
    ev.preventDefault()
    try {
      await dispatch(login(credentials)).unwrap()
      if (onClose) {
        onClose()
      } else {
        navigate('/')
      }
    } catch (err) {
      // השגיאה כבר טופלה בקונטרולר
    }
  }

  async function onGoogleLogin() {
    try {
      await dispatch(loginWithGoogle()).unwrap()
      if (onClose) {
        onClose()
      } else {
        navigate('/')
      }
    } catch (err) {
      // השגיאה כבר טופלה בקונטרולר
    }
  }

  // פונקציה לפתיחת מודל ההרשמה דרך Redux
  const handleOpenSignUp = () => {
    dispatch(openSignUp())
  }

  return (
    <section className="flex flex-col items-center">
      <div
        className="w-full flex flex-col bg-secondaryBackground items-center max-w-[450px] max-h-[750px] rounded-lg shadow-lg p-6"
        style={{
          border: '2px solid transparent',
          borderImage: `url(${images.redBorder}) 20 stretch`,
        }}
      >
        {/* כפתור סגירה – משתמשים ב־onClose אם קיים */}
        <button
          className="self-end mb-4"
          onClick={onClose ? onClose : () => navigate(-1)}
        >
          <img src={images.closeMenu} alt="Close Menu" className="w-10 h-10" />
        </button>

        {/* כותרות */}
        <div className="text-center mb-6">
          <h1 className="text-2xl text-softText mb-2">התחברות לאניזון</h1>
          <h2 className="text-sm text-muted">
            התחבר כדי להמשיך לצפות בתוכן המועדף עליך
          </h2>
        </div>

        {/* טופס */}
        <form className="flex flex-col gap-6 w-full" onSubmit={onLogin}>
          {/* אימייל */}
          <div className="flex flex-col">
            <input
              id="email"
              name="email"
              type="email"
              placeholder="אימייל"
              value={credentials.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 focus:border border-primary bg-secondary text-Text placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>

          {/* סיסמה */}
          <div className="flex flex-col relative">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              placeholder="סיסמה"
              value={credentials.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 focus:border border-primary bg-secondary text-Text placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute top-1/3 left-2"
            >
              <img
                src={
                  showPassword
                    ? signUpImages.passwordShow
                    : signUpImages.passwordHide
                }
                alt="Toggle Password Visibility"
                className="w-5 h-5"
              />
            </button>
          </div>
          {/* כפתור התחברות */}
          <Button
            text="התחברות"
            width={386}
            height={60}
            fontSize="text-lg"
            textColor="text-white"
            bgColor="fill-primary"
            type="submit"
            aria-label="התחבר לחשבון"
            title="התחברות לאניזון"
          />

          {/* קישורים מתחת לשדות */}
          <div className="flex items-center justify-center text-sm gap-4">
            <Link to="/forgot-password" className="hover:underline">
              שכחת סיסמה?
            </Link>
            <img src={animeSchedule.redDot} alt="Divider" />
            {/* החלפת ה-Link לכפתור שמפעיל את SignUpPopup */}
            <button
              type="button"
              onClick={handleOpenSignUp}
              className="hover:underline text-sm"
            >
              עדיין לא נרשמת?
            </button>
          </div>
        </form>

        {/* מחלק */}
        <img className="m-4 w-full" src={signUpImages.divider} alt="Divider" />

        {/* התחברות דרך צד שלישי */}
        <div className="flex justify-center w-full">
          <button
            onClick={onGoogleLogin}
            className="flex items-center justify-center w-full gap-3 px-4 py-2 bg-[#3A3A3A] hover:scale-105 transition-transform"
          >
            <img
              src={signUpImages.googleIcon}
              alt="Google sign up"
              className="w-6 h-6"
            />
            <span className="text-primaryText">התחברות עם גוגל</span>
          </button>
        </div>
      </div>
    </section>
  )
}
